import React from 'react';
import FooterOne from '../../common/footer/FooterOne';
import HeaderOne from '../../common/header/HeaderOne';
import BcrumbBannerOne from '../../elements/breadcrumb/BcrumbBannerOne';
import SectionTitle from '../../elements/section-title/SectionTitle';
import AboutTwo from '../../component/about/AboutTwo_Informatique';
import ColorSwitcher from '../../elements/switcher/ColorSwitcher';
import SEO from '../../common/SEO';
import OutrosServicos from '../OutrosServicos';
import { useTranslation } from 'react-i18next';
import ShapeBubble from '../../component/shapes/ShapeBubble';
import Tilty from 'react-tilty';

const ServiceDetails = () => {
    const { t } = useTranslation();
    
    return (
        <>
            <SEO title="Service Stategie Sociale" />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BcrumbBannerOne
                    title={t('IT Solutions')}
                    paragraph={t('ITSolutionsDescription')}
                    styleClass=""
                    mainThumb=""
                    tituloabranco="yes"
                />
                <AboutTwo></AboutTwo>
                <div className="section section-padding bg-color-light pb--70" id="sectionbaixo">

                    <div className="container">
                        <div className='row'>
                            <div className="col-lg-6 col-md-12 process-work order-2 order-lg-1">
                                <Tilty perspective={2000} style={{ width: '100%' }}>
                                    <div className="thumbnail_custom">
                                        <img src="/images/placeholder.webp" alt="Thumbnail" style={{ borderRadius: "10px", width: "610px", height: "460px" }} />
                                    </div>
                                </Tilty>
                            </div>
                            <div className="col-lg-6 col-md-12 content order-1 order-lg-2">
                                <p className="h3 title">{t('title_pc_builds')}</p>
                                <p>{t('pcbuilds_quote1')}</p><br></br>
                                <p>{t('pcbuilds_quote2')}</p>
                            </div>
                        </div>

                        <div className='row'>
                            <div className="content col-lg-6 col-md-12">
                                <p className="h3 title">{t('title_it_repairs')}</p>
                                <p>{t('itfix_quote1')}</p><br></br>
                                <p>{t('itfix_quote2')}</p>
                            </div>
                            <div className='col-lg-6 col-md-12 process-work content-reverse'>
                                <Tilty perspective={2000} style={{ width: '100%' }}>
                                    <div className="thumbnail_custom">
                                        <img src="/images/placeholder.webp" alt="Thumbnail" style={{ borderRadius: "10px", width: "610px", height: "460px" }} />
                                    </div>
                                </Tilty>
                            </div>
                        </div>

                        <div className='row'>
                            <div className="col-lg-6 col-md-12 process-work order-2 order-lg-1">
                                <Tilty perspective={2000} style={{ width: '100%' }}>
                                    <div className="thumbnail_custom">
                                        <img src="/images/placeholder.webp" alt="Thumbnail" style={{ borderRadius: "10px", width: "610px", height: "460px" }} />
                                    </div>
                                </Tilty>
                            </div>
                            <div className="col-lg-6 col-md-12 content order-1 order-lg-2">
                                <p className="h3 title">{t('title_system_optimization')}</p>
                                <p>{t('optimize_quote1')}</p><br></br>
                                <p>{t('optimize_quote2')}</p>
                            </div>
                        </div>

                        <div className='row'>
                            <div className="content col-lg-6 col-md-12">
                                <p className="h3 title">{t('title_consulting_setup')}</p>
                                <p>{t('consult_quote1')}</p><br></br>
                                <p>{t('consult_quote2')}</p>
                            </div>
                            <div className='col-lg-6 col-md-12 process-work content-reverse'>
                                <Tilty perspective={2000} style={{ width: '100%' }}>
                                    <div className="thumbnail_custom">
                                        <img src="/images/services/Informatique/ServiceItSolutions/consulting_setup.webp" alt="Thumbnail" style={{ borderRadius: "10px", width: "610px", height: "460px" }} />
                                    </div>
                                </Tilty>
                            </div>
                        </div>
                    </div>
                    <ul className="shape-group-17 list-unstyled">
                        {/* <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-24.png"} alt="Bubble" /></li> */}
                        <ShapeBubble />
                        <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/line-4.webp"} alt="Line" /></li>
                        <li className="shape shape-4"><img src={process.env.PUBLIC_URL + "/images/others/line-5.webp"} alt="Line" /></li>
                        <li className="shape shape-5"><img src={process.env.PUBLIC_URL + "/images/others/line-4.webp"} alt="Line" /></li>
                        <li className="shape shape-6"><img src={process.env.PUBLIC_URL + "/images/others/line-5.webp"} alt="Line" /></li>
                    </ul>
                </div>
                <div className="section section-padding">
                    <div className="container">
                        <SectionTitle
                            title={t("Nos autres services")}
                            description=""
                            textAlignment=""
                            textColor=""
                        />
                        <OutrosServicos></OutrosServicos>
                    </div>
                    <ul className="shape-group-16 list-unstyled">
                        <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/circle-2.webp"} alt="circle" /></li>
                        <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.webp"} alt="Line" /></li>
                    </ul>
                </div>
                <FooterOne parentClass="" />
            </main >
        </>
    )
}

export default ServiceDetails;